import axiosInstance from "@/services/axiosInterceptor";

const GetList = async (path) => {
  try {
    const response = await axiosInstance.get(path);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

const GetItem = async (path) => {
  try {
    const response = await axiosInstance.get(path);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

const PostItem = async (path, body) => {
  try {
    const response = await axiosInstance.post(path, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

const PatchItem = async (path, body) => {
  try {
    const response = await axiosInstance.patch(path, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

const PutItem = async (path, body) => {
  try {
    const response = await axiosInstance.put(path, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

const DeleteItem = async (path, body) => {
  try {
    const response = await axiosInstance.delete(path);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

export { GetList, GetItem, PostItem, PatchItem, PutItem, DeleteItem };
